import { Link } from "react-scroll";

const Footer = ({ contacts }) => {

	const contact_1 = contacts.contact_1;
	const contact_2 = contacts.contact_2;
	const contact_3 = contacts.contact_3_footer;

	const year = new Date().getFullYear();

	return (
		<footer className="wrapper__footer footer">
			<div className="footer__container">
				<div className="footer__body">
					<div className="footer__top top-footer">
						<div className='top-footer__body'>
							<div className="top-footer__logo">
								<img src="assets/images/icons/logo-black.svg" alt="" />
							</div>
							<div className="top-footer__footer-menu footer-menu">
								<nav className="footer-menu__body">
									<ul className="footer-menu__list">
										<li className="footer-menu__item"><Link to="section1" className="footer-menu__link _text-link">Профессии</Link></li>
										<li className="footer-menu__item"><Link to="section2" className="footer-menu__link _text-link">О нас</Link></li>
										<li className="footer-menu__item"><Link to="section3" className="footer-menu__link _text-link">Кому подходит?</Link></li>
										<li className="footer-menu__item"><Link to="section4" className="footer-menu__link _text-link">О работе платформы</Link></li>
										<li className="footer-menu__item"><Link to="section5" className="footer-menu__link _text-link">Отзывы</Link></li>
									</ul>
								</nav>
							</div>
							<a href={`tel:${contact_3}`} className="top-footer__phone-main _text-link">{contact_3}</a>
							<div className="top-footer__contacts">
								<a href={`tel:${contact_1}`} className="top-footer__phone _text-link">{contact_1}</a>
								<a href={`tel:${contact_2}`} className="top-footer__phone _text-link">{contact_2}</a>
							</div>
						</div>
					</div>
					<div className="footer__main main-footer">
						<div className="main-footer__body">
							<div className="main-footer__protect-info">© Все права защищены, 2010-{year} </div>
							<a href={`tel:${contact_3}`} className="main-footer__phone _text-link">{contact_3}</a>
						</div>
					</div>
				</div>
			</div>
		</footer>
	)

}

export default Footer;